module.exports = __webpack_public_path__ + "img/retrofit-details-8.3645e963.jpg";